import utils from './Utils';

export default class CellsAnalizer {
    static findWilds(cellModels)
    {
        const wildHashes = {
            'singer-diamond-microphone': 'singer_extra',
            'old-ring-teshib': 'old_extra',
            'guy-raki-glasses': 'guy_extra'
        };

        let result = cellModels
            // transform flat cell array to col:row matrix
            .reduce((acc, next) =>
            {
                let cell = next;
                if (cell.cellIndex === -1 || cell.cellIndex === 3)
                {
                    return acc;
                }

                acc[cell.slotIndex] = acc[cell.slotIndex] || new Array(3);
                acc[cell.slotIndex][cell.cellIndex] = cell.symbol;
                return acc;
            }, new Array(5))

            // do cells hash for each col
            .map((col) => col.join('-'))

            // collect wild combinations
            .reduce((acc, cellsCombinationHash, index) =>
            {
                let extraSymbol = wildHashes[cellsCombinationHash];
                let symbol = cellsCombinationHash.split('-')[0];
                if (extraSymbol)
                {
                    acc.push({ slotIndex: index, symbol, extraSymbol });
                }
                return acc;
            }, []);

        return result;
    }

    static analyze(cellModels)
    {
        return {
          wilds: CellsAnalizer.findWilds(cellModels)
        };
    }
}
